import React, {useState} from "react";
import { Box, Flex } from "theme-ui";
import Expectations from "./expectations/Expectations";
import Packages from './packages/Packages';
import ContentfulRichText from "./ContentfulRichText";

const ExpectationAndPackages = ({ expectationContent, packagesContent, pageType, version = '' }) => {
    const [showExpectation, setShowExpectation] = useState(pageType === 'expectations');

    return <Box className="expectation-package-container">
     <Flex sx={{justifyContent: 'right'}}>
        <button onClick={()=>setShowExpectation(true)} className={`button-left ${showExpectation && 'active-left'}`}>Expectations</button>
        <button onClick={()=>setShowExpectation(false)} className={`button-right ${!showExpectation && 'active-right'}`}>Packages</button>
     </Flex>
     {(expectationContent || packagesContent) &&
        <Box><ContentfulRichText richText={showExpectation ? expectationContent : packagesContent} textfontSize='16px'/></Box>
        }
     {showExpectation ? <Expectations version={version}/> : <Packages version={version}/>}
    </Box>;
};
export default ExpectationAndPackages;
